<!--
 * @Author: 汪俊洪
 * @Date: 2022-10-17 19:00:43
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-10-20 14:13:59
 * @Description: 订单评价
-->
<template>
  <div class="rate-wrap">
    <el-form :model="input" ref="input">
      <el-form-item :label="`${$t('ordervote.no')}：`">
        {{ detail.orderCode || '-' }}
      </el-form-item>
      <el-form-item :label="`${$t('ordervote.allof')}：`" prop="overallScore">
        <el-rate v-model="input.overallScore" disabled allow-half></el-rate>
      </el-form-item>
      <div class="divider"></div>
      <div class="rates">
        <el-form-item :label="`${$t('ordervote.quality')}：`" prop="qualityScore">
          <el-rate v-model="input.qualityScore" disabled allow-half></el-rate>
        </el-form-item>
        <el-form-item :label="`${$t('ordervote.feedback')}：`" prop="deliveryScore">
          <el-rate v-model="input.deliveryScore" disabled allow-half></el-rate>
        </el-form-item>
        <el-form-item :label="`${$t('ordervote.service')}：`" prop="serviceScore">
          <el-rate v-model="input.serviceScore" disabled allow-half></el-rate>
        </el-form-item>
        <el-form-item :label="`${$t('ordervote.price')}：`" prop="priceScore">
          <el-rate v-model="input.priceScore" disabled allow-half></el-rate>
        </el-form-item>
      </div>
      <el-form-item :label="`${$t('ordervote.discribe')}：`" prop="remark">
        <el-input
          type="textarea"
          placeholder=""
          v-model="input.remark"
          maxlength="500"
          disabled
          :autosize="{ minRows: 3, maxRows: 6 }"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item prop="payOrderItemEvaluationList">
        <el-table
          :data="showList"
          height="350"
          border
          :stripe="true"
          style="width: 100%"
        >
          <el-table-column prop="goodsCode" show-overflow-tooltip :label="`${$t('ordervote.orderCode')}：`">
          </el-table-column>
          <el-table-column prop="goodsName" show-overflow-tooltip :label="`${$t('ordervote.productName')}：`">
          </el-table-column>
          <el-table-column prop="goodsModel" show-overflow-tooltip :label="`${$t('ordervote.model')}：`"> </el-table-column>
          <el-table-column prop="address" :label="`${$t('ordervote.rate')}：`">
            <template slot-scope="scope">
              <el-rate v-model="scope.row.overallScore" disabled allow-half></el-rate>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </el-form-item>
      <el-form-item label="" class="align-center">
        <el-button
          class="default-btn"
          :loading="butLoading"
          @click="handleClose"
          size="small"
          >{{$t('notice.close')}}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      butLoading: false,
      input: {
        overallScore: 5, // 整体评价
        qualityScore: 5, // 态度评价
        deliveryScore: 5, // 物流评价
        serviceScore: 5, // 物流评价
        priceScore: 5, // 物流评价
        remark: '', // 评价内容
        payOrderItemEvaluationList: []
      },
      page: {
        page: 1,
        limit: 10
      },
      total: 0,
      showList: []
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      this.$http.get(`/front/v1/pay-order-evaluations/${this.detail.orderId}`).then(({ data: res }) => {
        if (res.code === 0) {
          let arr = Object.keys(this.input)
          arr.forEach((key) => {
            this.input[key] = res.data[key]
          })
          this.getItem()
        }
      })
    },
    getItem () {
      this.$http.get(`/front/v1/pay-order-evaluations/${this.detail.orderId}/pay-order-item-evaluations?page=${this.page.page}&limit=${this.page.limit}`).then(({ data: res }) => {
        if (res.code === 0) {
          this.showList = res.data.records
          this.total = res.data.total - 0
        }
      })
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.page.page = val
      // 刷新列表数据
      this.getItem()
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.page.page = 1
      this.page.limit = val
      // 刷新列表数据
      this.getItem()
    },
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.rate-wrap {
  margin-top: -20px;
  /deep/ .el-form-item__label {
    line-height: 28px;
  }
  /deep/ .el-form-item__content {
    line-height: 28px;
  }
  /deep/ .el-form-item {
    margin-bottom: 12px;
  }
}
.divider {
    height: 1px;
    background: #DCDFE6;
    margin-bottom: 12px;
}
.rates {
    display: flex;
    flex-wrap: wrap;
    >div {
        width: 50%;
    }
}
.align-center {
  text-align: center;
}
</style>
